"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentFailConfig = void 0;
const OrganizationConnectionBaseEntity_1 = require("../../entity/OrganizationConnectionBaseEntity");
/**
 * payment fail config - is the entity that configure the way we should handle failures
 * in "freeze" before trying to charge again ( relevant just in scheduled payments ).
 *
 */
class PaymentFailConfig extends OrganizationConnectionBaseEntity_1.OrganizationConnectionBaseEntity {
}
exports.PaymentFailConfig = PaymentFailConfig;
//# sourceMappingURL=PaymentFailConfig.js.map